import { render, staticRenderFns } from "./create-or-edit-tag.vue?vue&type=template&id=05d4bcdc&scoped=true&"
import script from "./create-or-edit-tag.vue?vue&type=script&lang=js&"
export * from "./create-or-edit-tag.vue?vue&type=script&lang=js&"
import style0 from "./create-or-edit-tag.vue?vue&type=style&index=0&id=05d4bcdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d4bcdc",
  null
  
)

export default component.exports